import React, { useEffect, useState } from "react";
import { Button } from "@mui/joy";
import { Menu, X } from "lucide-react";
import ColorSchemeToggle from "../../Utils/ColorSchemeToggle";

export default function Header({ dark }: { dark: boolean }) {
  useEffect(() => {}, [dark]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <header
      className="px-4 lg:px-6 h-16 flex items-center border-b border-[#E2E8F0] backdrop-blur-sm dark:bg-gray-900/80 sticky top-0 z-50"
      style={{ backgroundColor: dark ? "" : "#f9fafb" }}
    >
      <div className="flex items-center justify-between w-full">
        <div>
          <a className="flex items-center justify-center" href="/">
            <img
              className="w-auto h-12 mr-4"
              src="/assets/logofinal.png"
              alt="CompanyLogo"
            />
            <span
              className="font-bold text-xl text-[#7B3FE4] whitespace-nowrap"
              style={{ letterSpacing: "0.05em" }}
            >
              HackTheWay
            </span>
          </a>
        </div>
        <div>
          <nav
            className={`ml-auto flex items-center gap-4 md:gap-6 ${
              isMenuOpen
                ? "flex-col absolute top-16 left-0 right-0 bg-white dark:bg-gray-900 p-4 shadow-md"
                : "hidden"
            } md:flex md:flex-row md:relative md:top-0 md:bg-transparent md:p-0 md:shadow-none`}
            style={{ backgroundColor: dark ? "" : "#f9fafb" }}
          >
            <a
              className="text-md font-medium hover:text-[#7B3FE4] transition-colors"
              href="#features"
            >
              Features
            </a>
            <a
              className="text-md font-medium hover:text-[#7B3FE4] transition-colors"
              href="#academy"
            >
              Academy
            </a>
            <a
              className="text-md font-medium hover:text-[#7B3FE4] transition-colors"
              href="#events"
            >
              Events
            </a>

            <a
              className="text-md font-medium hover:text-[#7B3FE4] transition-colors"
              href="#testimonials"
            >
              Testimonials
            </a>
            <a
              className="text-md font-medium hover:text-[#7B3FE4] transition-colors"
              href="#gallery"
            >
              Gallery
            </a>

            <div className="mt-4 md:hidden">
              <Button
                variant="outlined"
                size="md"
                className="border-[#7B3FE4] text-[#7B3FE4] hover:bg-[#7B3FE4] hover:text-white w-full"
                onClick={() => {
                  window.location.href = "/signin";
                }}
              >
                Log In
              </Button>

              <Button
                size="md"
                className="bg-[#7B3FE4] text-white hover:bg-[#6B2FD4] w-full mt-2"
                onClick={() => {
                  window.location.href = "/signup";
                }}
              >
                Sign Up
              </Button>
            </div>
          </nav>
        </div>
        <div className="flex flex-row">
          <div className="flex items-center gap-4 ml-auto md:ml-4">
            <Button
              variant="outlined"
              size="md"
              className="border-[#7B3FE4] text-[#7B3FE4] hover:bg-[#7B3FE4] hover:text-white hidden md:flex"
              onClick={() => {
                window.location.href = "/signin";
              }}
            >
              Log In
            </Button>
            <Button
              size="md"
              className="bg-[#7B3FE4] text-white hover:bg-[#6B2FD4] hidden md:flex"
              onClick={() => {
                window.location.href = "/signup";
              }}
            >
              Sign Up
            </Button>
          </div>
          <div className="flex items-center gap-4 ml-auto md:ml-4">
            <ColorSchemeToggle size="md" sx={{ ml: "auto" }} />
            <button onClick={toggleMenu} className="md:hidden p-2">
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
